import React from "react";
import { Layout, Card, Row, Col, Typography, theme } from "antd";
import {
  FileTextOutlined,
  ShopOutlined,
  BankOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import HeaderApp from "../../shared/components/HeaderApp";
import NavigationBar from "../../shared/components/NavigationBar";

const { Title, Text } = Typography;

interface MenuItem {
  title: string;
  description: string;
  icon: React.ReactNode;
  color: string;
  bgColor: string;
  path: string;
  className?: string;
}

const DashboardCompany: React.FC = () => {
  const navigate = useNavigate();
  const { token } = theme.useToken();

  const menuItems: MenuItem[] = [
    {
      title: "Facturas",
      description: "Gestión de facturación",
      icon: <FileTextOutlined style={{ fontSize: "30px" }} />,
      color: token.colorPrimary,
      bgColor: "rgba(43, 140, 238, 0.1)",
      path: "/facturas",
    },
    {
      title: "Mi Empresa",
      description: "Editar detalles y perfil",
      icon: <ShopOutlined style={{ fontSize: "30px" }} />,
      color: token.colorSuccess,
      bgColor: "rgba(16, 185, 129, 0.1)",
      path: "/empresa/detalles",
    },
    {
      title: "Contabilidad",
      description: "Reportes financieros",
      icon: <BankOutlined style={{ fontSize: "30px" }} />,
      color: token.colorWarning,
      bgColor: "rgba(245, 158, 11, 0.1)",
      path: "/empresa/dashboard",
      className: "disabled",
    },
  ];

  return (
    <>
      <HeaderApp
        sectionName="Menú de Gestión de Empresa"
        showBack
        backPath="/dashboard"
      />

      <Layout.Content style={{ padding: "20px", paddingBottom: "100px" }}>
        <Row gutter={[16, 16]}>
          {menuItems.map((item, index) => (
            <Col xs={24} key={index}>
              <Card
                size="small"
                hoverable
                className={item.className}
                style={{ borderRadius: "16px", cursor: "pointer" }}
                bodyStyle={{ padding: "24px" }}
                onClick={() => navigate(item.path)}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "16px",
                      backgroundColor: item.bgColor,
                      color: item.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      transition: "transform 0.2s ease",
                    }}
                  >
                    {item.icon}
                  </div>
                  <div style={{ marginLeft: "20px", flex: 1 }}>
                    <Title
                      level={4}
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: 800,
                        color: token.colorTextHeading,
                      }}
                    >
                      {item.title}
                    </Title>
                    <Text style={{ color: token.colorTextSecondary, fontSize: "12px" }}>
                      {item.description}
                    </Text>
                  </div>
                  <ArrowRightOutlined
                    style={{ color: token.colorTextPlaceholder, fontSize: "18px" }}
                  />
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Layout.Content>

      <NavigationBar activeKey="/empresa/dashboard" />
    </>
  );
};

export default DashboardCompany;
